export default __webpack_public_path__ + "static/media/astro_sit_with_flower.0a00dc76.png";